import { fullImagePath } from '../../b2b-common/helpers';
import './LevelNCard.css';

import React from 'react';

const LevelNCard = ({ levelN }) => {
    return (
        <div className='levelN-card-container'>
            <img className='levelN-image' src={fullImagePath(levelN.imagePath)} alt={levelN.levelN_ItemName} />
            <div className='levelN-name'>{levelN.levelN_ItemName}</div>
        </div>
    );
};

export default LevelNCard;